"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var pokeballEgg = {
    name: "pokeball",
    enabled: false,
    trigger: {
        type: "keys",
        keystrokes: ["p", "o", "k", "e", "b", "a", "l", "l"],
        captureOnInputs: false
    },
    onStart: function () {
        var data = "https://i.imgur.com/bcM1F8u.gif";
        var shock = document.createElement("div");
        var img = new Image();
        img.src = data;
        img.style.width = "500px";
        img.style.height = "350px";
        img.style.transition = "8s all linear";
        img.style.position = "fixed";
        img.style.left = "-450px";
        // img.style.bottom = 'calc(-50% + 300px)'
        img.style.bottom = "-10px";
        img.style.zIndex = "999999";
        document.body.appendChild(img);
        // window.setTimeout(function(){
        //   img.style.left = 'calc(50% - 200px)'
        // },50)
        window.setTimeout(function () {
            img.style.left = "calc(100% + 500px)";
        }, 50);
        window.setTimeout(function () {
            img.parentNode.removeChild(img);
        }, 8000);
    },
};
exports.default = pokeballEgg;
